import { AjaxError } from 'rxjs';
import { empty } from 'rxjs/observable/empty';
import { catchError } from 'rxjs/operators/catchError';
import { LOG_TYPES } from '../../constants/logger';
import {ReportErrorSerializer} from '../../models';
import { AuthService } from '../../services';
import ajax from '../../utils/ajax';

const zenossUrl = process.env.REACT_APP_ZENOSS_URL || '';

class ZenossService {
    /**
    Send error to zenoss
    @param {Object} errorLog ErrorLog Object
    @param {Object} [severity=LOG_TYPES.DEBUG] LOG_TYPES
    @returns {Observable} Observable that emits the normalized response
   */
  send = (errorLog, severity = LOG_TYPES.DEBUG) => {
    if (!errorLog || !errorLog.message) throw Error('Incorrect Arguments');
    if (errorLog instanceof AjaxError) {
      errorLog.url = errorLog.request.url;
    }
    const tokenData = AuthService.getToken();
    if (tokenData && tokenData.access_token) {
      return ajax(
        {
          url: `${zenossUrl}`,
          body: ReportErrorSerializer.serialize(errorLog, severity),
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
          responseType: 'json'
        }
      )
      .pipe(catchError(() => empty()));
    } else {
      return empty();
    }
  }

  error = (errorLog) => {
    return this.send(errorLog, LOG_TYPES.ERROR);
  }

  warn = (errorLog) => {
    return this.send(errorLog, LOG_TYPES.WARN);
  }

  debug = (errorLog) => {
    return this.send(errorLog, LOG_TYPES.DEBUG);
  }
}

export default (function () {
  const zenossService = new ZenossService();

  // Intercepting Console Warnings
  const consoleWarn = console.warn.bind(console)
  console.warn = (...args) => {
    // Encapsulating logging code in try catch to prevent cyclic error logging if error logging fails
    try {
      zenossService.warn({
        message: args.join('\n'),
        source: 'console.warn'
      }).subscribe();
    } catch (e) { }
    consoleWarn(...args)
  }

  // Intercepting Console Errors
  const consoleError = console.error.bind(console)
  console.error = (...args) => {
    // Encapsulating logging code in try catch to prevent cyclic error logging if error logging fails
    try {
      zenossService.error({
        message: args.join('\n'),
        source: 'console.error'
      }).subscribe();
    } catch (e) { }
    consoleError(...args);
  }

  // Catching Uncaught Javascript Errors
  window.addEventListener('error', function(event) {
    // Encapsulating logging code in try catch to prevent cyclic error logging if error logging fails
    try {
      const error = event.error;
      error.message = event.message;
      error.source = 'window.onerror';
      zenossService.error(error).subscribe();
    } catch (e) { }
  })

  // Catching Unhandled Javascript Promise Rejections
  window.addEventListener("unhandledrejection", function(event) {
    // Encapsulating logging code in try catch to prevent cyclic error logging if error logging fails
    try {
      zenossService.error({
        message: event.reason.stack,
        source: 'window.unhandledrejection'
      }).subscribe();
    } catch (e) { }
  });

  return zenossService;
}());



// WEBPACK FOOTER //
// ./src/services/logger/index.js